import React, { useState, useEffect, useRef } from 'react'
import MessageItem from './MessageItem'

interface CommsDrawerProps {
  onClose: () => void
}

interface Message {
  id: string
  sender: string
  content: string
  timestamp: Date
}

const CommsDrawer: React.FC<CommsDrawerProps> = ({ onClose: _onClose }) => {
  const [messages, setMessages] = useState<Message[]>([])
  const [inputText, setInputText] = useState('')
  const messagesEndRef = useRef<HTMLDivElement>(null)

  // Mock data for demonstration
  useEffect(() => {
    const mockMessages: Message[] = [
      {
        id: '1',
        sender: 'Crew A',
        content: 'Track 3 sweep complete, 3 missing cars identified',
        timestamp: new Date(Date.now() - 300000)
      },
      {
        id: '2',
        sender: 'Dispatcher',
        content: 'Copy that, please proceed with reconciliation',
        timestamp: new Date(Date.now() - 240000)
      },
      {
        id: '3',
        sender: 'Crew A',
        content: 'Ghost car CSX101 confirmed on track, updating records',
        timestamp: new Date(Date.now() - 180000)
      }
    ]
    setMessages(mockMessages)
  }, [])

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' })
  }, [messages])

  const handleSendMessage = () => {
    if (inputText.trim()) {
      const newMessage: Message = {
        id: Date.now().toString(),
        sender: 'Dispatcher',
        content: inputText,
        timestamp: new Date()
      }
      setMessages([...messages, newMessage])
      setInputText('')
    }
  }

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      handleSendMessage()
    }
  }

  return (
    <div className="comms-drawer">
      <h2>Communications</h2>
      <div className="messages-list">
        {messages.map((message) => (
          <MessageItem key={message.id} message={message} />
        ))}
        <div ref={messagesEndRef} />
      </div>
      <div className="ptt-input">
        <textarea
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Push-to-Text: Type message..."
          rows={2}
        />
        <button className="btn-send" onClick={handleSendMessage}>
          Send
        </button>
      </div>
    </div>
  )
}

export default React.memo(CommsDrawer)
